import React from "react";
import { connect } from "react-redux";
import TextBox from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';
import LookUpItemGrid from "./LookUpItemGrid";
import LookUpLotGrid from "./LookUpLotGrid";
import LookUpSubLotGrid from "./LookUpSubLotGrid";
import LookUpLocationGrid from "./LookUpLocationGrid";
import ApiRoute from "../../assets/apiRoutes.json";
import axios from "axios";
import Accordion from 'devextreme-react/accordion';
import Toolbar, { Item } from "devextreme-react/toolbar";

let accessToken = '';
const searchpanel = [
    {
      ID: 1,
      Name: 'Search Filters'
    }
    
  ];
class LookUpForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            animationDuration: 300,
            selectedItems: searchpanel,
            lookupname: this.props.lookupname,
            from: "",
            to: "",
            code: "",
            description: "",
            responsesource: null,
            isVisibleItemGrid: false,
            isVisibleLotGrid: false,
            isVisibleSubLotGrid: false,
            isVisibleLocationGrid: false,
            itemcode: '',
            lotcode: '',
            sublotcode: '',
            locationcode: '',
            cdata: ''
            //gridcolumns: colsArray.filter(x => x.type = props.lookupname.toLowerCase()),
        };
        accessToken = props.oidc.user.access_token;
        this.DoneRecord = this.DoneRecord.bind(this);
        this.handleCallback = this.handleCallback.bind(this);
        this.SearchRecord = this.SearchRecord.bind(this);
        this.selectionChanged = this.selectionChanged.bind(this);
    }
    componentDidMount() {
        this.SearchRecord();
    }
    componentWillUnmount() {
        this.ResetRecord();
    }
    ResetRecord=(e)=> {
        if(e?.event)
            e.event.stopPropagation();
        this.setState({
            from: "",
            to: "",
            code: "",
            description: "",
            responsesource: null,
            lookupname: ""
        });
    }
    SearchRecord(e) {
        if(e?.event)
           e.event.stopPropagation();
        if (this.props && this.props.lookupname) {
            this.setState({
                lookupname: this.props.lookupname
            });
        }
        var searchRequestObj = {};
        searchRequestObj.from = this.state.from;
        searchRequestObj.to = this.state.to;
        searchRequestObj.code = this.state.code;
        searchRequestObj.description = this.state.description;
        if ((this.props && this.props.lookupname && this.props.lookupname == "Item") || this.state.lookupname == "Item")
            searchRequestObj.lookupType = `${ApiRoute.ReportSearchLookUp.ItemLookUp}`;
        else if ((this.props && this.props.lookupname && this.props.lookupname == "Lot") || this.state.lookupname == "Lot")
            searchRequestObj.lookupType = `${ApiRoute.ReportSearchLookUp.LotLookUp}`;
        else if ((this.props && this.props.lookupname && this.props.lookupname == "SubLot") || this.state.lookupname == "SubLot")
            searchRequestObj.lookupType = `${ApiRoute.ReportSearchLookUp.SubLotLookUp}`;
        else if ((this.props && this.props.lookupname && this.props.lookupname == "Location") || this.state.lookupname == "Location")
            searchRequestObj.lookupType = `${ApiRoute.ReportSearchLookUp.LocationLookUp}`;
        this.LoadLookUpData(searchRequestObj);
    }
    selectionChanged(e) {
        let newItems = [...this.state.selectedItems];
        e.removedItems.forEach((item) => {
          const index = newItems.indexOf(item);
          if (index >= 0) {
            newItems.splice(index, 1);
          }
        });
        if (e.addedItems.length) {
          newItems = [...newItems, ...e.addedItems];
        }
        this.setState({
          selectedItems: newItems
        });
      }
    LoadLookUpData(lookupSearchRequest) {
        axios
            .post(
                `${window._env_.REACT_APP_APIS}/` + lookupSearchRequest.lookupType,
                lookupSearchRequest,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                    },
                }
            )
            .then((res) => {
                this.setState({
                    responsesource: res?.data?.lookups,
                    isVisibleItemGrid : (this.props && this.props.lookupname && this.props.lookupname == "Item") || this.state.lookupname == "Item",
                    isVisibleLocationGrid: (this.props && this.props.lookupname && this.props.lookupname == "Location") || this.state.lookupname == "Location",
                    isVisibleLotGrid: (this.props && this.props.lookupname && this.props.lookupname == "Lot") || this.state.lookupname == "Lot",
                    isVisibleSubLotGrid: (this.props && this.props.lookupname && this.props.lookupname == "SubLot") || this.state.lookupname == "SubLot"
                });
            })
            .catch((err) => {
                console.log(err, "err in loading look up data");
            });
    }
    DoneRecord() {
        this.props.parentCallbackLookUp(this.state.cdata);
    }
    handleCallback(ChildData){
        this.setState({
            cdata: ChildData
        });
    }
    
    render() {
        return (    
            <>
                <Accordion
                  dataSource={searchpanel}
                  collapsible={true}
                  multiple={false}
                  animationDuration={300}
                  selectedItems={this.state.selectedItems}
                  onSelectionChanged={e => {
                    if (e.currentTarget === e.target) {
                      this.selectionChanged(e, e.target);
                    }
                  }}
                  className="accordion-height"
                  itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                     <Item location="after">
                     <Button onClick={this.SearchRecord} className="accordianButton" text="Search" type="default"/>
                     </Item>
                       <Item location="after">
                       <Button onClick={this.ResetRecord} className="accordianButton" text="Reset"/>
                       </Item>
                       <Item location="after">
                       <Button onClick={this.DoneRecord} className="accordianButton" text="Done"/>
                       </Item>

                    </Toolbar>
                  )}
                  itemRender={(itemProps) => (
                    this.state.lookupname != "Location" &&(
                      <div className="row">
                        <div className="col-md-3">
                        <TextBox
                                className="input-field"
                                id="lukup-from"
                                type="text"
                                name="lookUpFrom"
                                stylingMode='outlined'
                                labelMode="static"
                                label="From"
                                value={this.state.from}
                                onValueChanged={(data) => this.setState({ from: data.value })}
                            />
                        </div>
                        <div className="col-md-3">
                        <TextBox
                                className="input-field"
                                id="lukup-to"
                                type="text"
                                name="lookUpTo"
                                stylingMode='outlined'
                                labelMode="static"
                                label="To"
                                value={this.state.to}
                                onValueChanged={(data) => this.setState({ to: data.value })}
                            />
                        </div>
                        <div className="col-md-3">
                        <TextBox
                            className="input-field"
                            id="lukup-code"
                            type="text"
                            name="lookUpCode"
                            stylingMode='outlined'
                            labelMode="static"
                            label={this.props.lookupname + " Code:"}
                            value={this.state.code}
                            onValueChanged={(data) => this.setState({ code: data.value })}
                        />
                        </div>
                        <div className="col-md-3">
                        <TextBox
                            className="input-field"
                            id="lukup-description"
                            type="text"
                            name="lookUpDescription"
                            stylingMode='outlined'
                            labelMode="static"
                            label={this.props.lookupname + " Description:"}
                            value={this.state.description}
                            onValueChanged={(data) => this.setState({ description: data.value })}
                        />
                        </div>
                    </div>)
                  )}
                  id="accordion-container"
                />

                <div className="row">
                    <div id="data-grid-lookup" className="mt-2">
                        {
                            (this.state.isVisibleItemGrid && this.props?.lookupname && this.state?.lookupname && this.state?.lookupname == "Item") && 
                                    <LookUpItemGrid databanck={this.state.responsesource} parentCallback={this.handleCallback} selectedItems={this.state.selectedItems}></LookUpItemGrid>
                        }
                        {
                            (this.state.isVisibleLotGrid && this.props?.lookupname && this.state?.lookupname && this.state?.lookupname == "Lot") && 
                                    <LookUpLotGrid databanck={this.state.responsesource} parentCallback={this.handleCallback} selectedItems={this.state.selectedItems}></LookUpLotGrid>
                        }
                        {
                            (this.state.isVisibleSubLotGrid && this.props?.lookupname && this.state?.lookupname && this.state?.lookupname == "SubLot") && 
                                    <LookUpSubLotGrid databanck={this.state.responsesource} parentCallback={this.handleCallback} selectedItems={this.state.selectedItems}></LookUpSubLotGrid>
                        }
                        {
                            (this.state.isVisibleLocationGrid && this.props?.lookupname && this.state?.lookupname && this.state?.lookupname == "Location") && 
                                    <LookUpLocationGrid databanck={this.state.responsesource} parentCallback={this.handleCallback} selectedItems={this.state.selectedItems}></LookUpLocationGrid>
                        }
                    </div>
                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LookUpForm);